import PropTypes from 'prop-types';
import React from 'react';

export default function AttachmentCell({ value }) {
  if (value) {
    return <>{value}</>;
  }

  return <a href="#">+Add</a>;
}

AttachmentCell.propTypes = {
  value: PropTypes.string,
};
